import RatingPage from '@components/RatingPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'fruits_and_veggies'

const ANSWER_TEXTS = {
  '1': 'Much less than regular',
  '2': 'Less than regular',
  '3': 'Somewhat regular',
  '4': 'Regular',
  '5': 'Very regular',
}

export default function FruitsAndVeggiesPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the rating value from the form
    const formData = new FormData(event.currentTarget)
    const rating = formData.get('rating') as string

    if (!rating) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Do you include fruits and veggies in your meals?',
      answer_key: rating,
      answer: ANSWER_TEXTS[rating as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <RatingPage
      title="pages.onboarding.fruitsAndVeggies.heading"
      minSubtitle="pages.onboarding.fruitsAndVeggies.options.rarely"
      maxSubtitle="pages.onboarding.fruitsAndVeggies.options.regularly"
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
